var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"LearningCenterSingle learning-single"},[_c('PostContent',{attrs:{"post-data":_vm.data,"show-thumbnail-category":"","subscribe":"","has-tags":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }